import * as React from 'react';

import styles from './Modal.module.scss';
import classNames from 'classnames';

interface TitleNoticeProps {
	text: string;
	isInline?: boolean;
}

const TitleNotice: React.FC<TitleNoticeProps> = ({ text, isInline }) => {
	return (
		<span
			className={classNames(styles.titleNotice, {
				[styles.titleNoticeInline]: isInline,
			})}
		>
			{text}
		</span>
	);
};

export const getOptionalLabel = (labelText: string, customOptionalText?: string) => {
	return (
		<>
			{labelText}{' '}
			<TitleNotice
				isInline
				text={customOptionalText ? `(${customOptionalText})` : '(Optional)'}
			></TitleNotice>
		</>
	);
};

export default TitleNotice;
